import React from 'react';
import { AppBar, Box, ThemeProvider, Toolbar } from '@mui/material';
import { authenticate } from '../../services/auth';
import './style.scss'
import theme from '../../theme';

const OtherBar = () => {
  return (
    <div className='headerContainer'>
      <div className="center">
        <ThemeProvider theme={theme}>
          <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static" className={'header'} color="primary" id='navbar'>
              <Toolbar sx={{ justifyContent: 'flex-end' }}>
                <button className="button" id="otherbar-link" onClick={() => window.open("https://docs.derupt.io/user/get-started")}>Get Started</button>
                <button className="button" id="otherbar-btn" onClick={() => authenticate()} >Connect Wallet</button>
              </Toolbar>
            </AppBar>
          </Box>
        </ThemeProvider>
      </div>
    </div>
  );
};

export default OtherBar;
